import styled from 'styled-components';
export var HeaderContainer = styled.div.withConfig({
  displayName: "style__HeaderContainer",
  componentId: "wqzjlw-0"
})(["top:0;display:flex;position:relative;flex-direction:row;border-radius:1%;height:70px;width:100%;"]);
export var CloseButton = styled.div.withConfig({
  displayName: "style__CloseButton",
  componentId: "wqzjlw-1"
})(["position:absolute;width:19px;height:50px;font-style:normal;font-weight:normal;line-height:normal;cursor:pointer;margin-right:30px;font-size:36px;color:rgba(0,0,0,0.3);right:0;"]);